import React from 'react';
import BzmIcon from '../../icons/BzmIcon';
import i18n from '../../../i18n';

interface StopMockBtnProps {
  id: string | number;
  onStop: () => void;
  disabled: boolean;
}

const StopMockBtn = ({ id, onStop, disabled }: StopMockBtnProps) => {
  return (
    <button
      id={`mockServiceStopButton` + id}
      className="btn btn-secondary btn-square"
      title={i18n.t('mockServices:mockServicesTable.stopMockService')}
      onClick={onStop}
      disabled={disabled}
    >
      <BzmIcon variant={'icon-bzm-stop-abort'} />
    </button>
  );
};

export default StopMockBtn;
